(ns global.endor.checkout.api.request
  (:require [global.endor.checkout.api.transit :as endor-transit]
            [re-frame.core :as rf]
            [superstructor.re-frame.fetch-fx :as fetch-fx]))

(def RequestStatus
  [:enum :pending :success :failure])

(def Request
  [:map
   [:status RequestStatus]
   [:error {:optional true} any?]
   [:params map?]])

(def ApiRequests
  [:map-of :uuid Request])

(defn with-headers [{:as fetch-params
                     :keys [headers]}]
  (assoc fetch-params
         :headers
         (merge {"Accept" "application/transit+json"}
                headers)))

(defn fetch-params
  [{:as params
    :keys [body
           response-content-types request-content-type
           timeout]}]
  (cond-> (with-headers params)

    (not response-content-types)
    (assoc :response-content-types
           {#"application/json" :json
            #"application/transit\+json" {:reader-kw :text
                                          :reader-fn endor-transit/read-transit}})

      ;; Default to transit, if :request-content-type not specified
    (and body
         (not request-content-type))
    (-> (assoc :body (endor-transit/write-transit body))
        (assoc-in [:headers "Content-Type"] "application/transit+json"))

      ;; Add default timeout
    (not timeout)
    (assoc :timeout 5000)))

(defn fetch [effects]
  (doseq [effect (fetch-fx/->seq effects)]
    (fetch-fx/fetch (fetch-params effect))))

(rf/reg-fx
 ::fetch
 fetch)

(rf/reg-event-fx
 ::fetch
 (fn [{:keys [db]} [_ params]]
   ;; TODO: If the same :id is provided twice in a row, or even same parameters,
   ;;       we risk in the success/failure handlers, mixing the responses of the requests with each other
   ;;       since responses might arrive out-of-order.
   ;;       Dealing with out-of-order responses might be out of scope of "internals" even,
   ;;       although we could have default of accepting responses just for the latest fetch,
   ;;       but allow caller to decide on a strategy.
   (let [request-id (or (:id params) (str (hash params)))]
     {:db (assoc-in db
                    [::db request-id]
                    {:status :pending
                     :params params})
      ::fetch (assoc params
                     :on-success [::fetch-success params request-id]
                     :on-failure [::fetch-failure params request-id])})))

(rf/reg-event-fx
 ::fetch-success
 (fn [{:keys [db]} [_ {:keys [on-success]} request-id response]]
   (cond-> {:db (assoc-in db [::db request-id :status] :success)}
     on-success (assoc :dispatch (conj on-success response)))))

(rf/reg-event-fx
 ::fetch-failure
 (fn [{:keys [db]} [_ {:keys [on-failure]} request-id error]]
   (cond-> {:db (-> db
                    (assoc-in [::db request-id :status] :failure)
                    (assoc-in [::db request-id :error] error))}
     on-failure (assoc :dispatch (conj on-failure error)))))
